import apiService from './apiService.js';

const resource = '/metabase';

export default {
    getSlbsToolToken() {
        return apiService.get(`${resource}/slbs-tool-token`);
    }
};
